import { render, staticRenderFns } from "./OtherConnector.vue?vue&type=template&id=81b0f582&scoped=true"
import script from "./OtherConnector.vue?vue&type=script&lang=js"
export * from "./OtherConnector.vue?vue&type=script&lang=js"
import style0 from "./OtherConnector.vue?vue&type=style&index=0&id=81b0f582&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b0f582",
  null
  
)

export default component.exports